import { PageWrapper, Button } from "kit/ui";

import error404 from "./assets/404-error.svg";



export default function ErrorPage() {

  return (
    <PageWrapper
      centered
      hideFooter
      style={{
        alignItems: "center"
      }}>
      <div>
        <img
          css={{
            width: "100%",
            height: "auto",
            marginBottom: 50
          }}
          src={error404}
          alt="Error Image" />

        <Button
          theme="primary"
          href="/"
          as="a"
          content="Ir a la p&aacute;gina de inicio" />
      </div>
    </PageWrapper>
  );
}
